<!-- listing-layout.component.html -->
<div class="w-100">
  <div class="d-flex justify-content-between align-items-center mb-4 w-100">
    <div>
      <ng-content select="[listing-heading]"></ng-content>
    </div>
    <div class="action-btn">
      <ng-content select="[listing-action-button]"></ng-content>
    </div>
  </div>
  <ng-content select="[listing-content]"></ng-content>
  <ng-content select="[listing-pagination]"></ng-content>
</div>
